<template>
  <CDropdown variant="nav-item" placement="bottom-end" @show="muat">
    <!-- .prevent: toggle dirender <a href="#">, tanpa ini rute pindah ke dashboard -->
    <CDropdownToggle class="position-relative py-0 px-2" :caret="false" aria-label="Notifikasi" @click.prevent>
      <CIcon icon="cil-bell" size="lg" />
      <CBadge v-if="belum" color="danger" shape="rounded-pill" class="position-absolute top-0 start-100 translate-middle lonceng-badge">{{ belum > 99 ? '99+' : belum }}</CBadge>
    </CDropdownToggle>
    <CDropdownMenu class="pt-0 lonceng-menu">
      <CDropdownHeader class="bg-body-secondary fw-semibold py-2 d-flex justify-content-between align-items-center">
        Notifikasi
        <CButton v-if="belum" size="sm" color="link" class="p-0 small" @click.stop="bacaSemua">Tandai semua dibaca</CButton>
      </CDropdownHeader>
      <div v-if="!daftar.length" class="px-3 py-3 small text-muted">Belum ada notifikasi.</div>
      <CDropdownItem v-for="n in daftar" :key="n.id" component="button" type="button" class="text-wrap py-2" :class="{ 'fw-semibold': !n.dibaca_at }" @click="buka(n)">
        <div class="small">{{ n.judul }}</div>
        <div class="small text-body-secondary fw-normal">{{ n.pesan }}</div>
        <div class="text-body-secondary fw-normal" style="font-size: 11px">{{ n.created_at }}</div>
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
// Lonceng notifikasi di header (t_notifikasi via akun/notifikasi). Dimuat ulang tiap 5 menit.
import axios from 'axios'

export default {
  name: 'NotifikasiLonceng',
  data() {
    return { daftar: [], belum: 0, timer: null }
  },
  mounted() {
    this.muat()
    this.timer = setInterval(this.muat, 5 * 60 * 1000)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    async post(endpoint, data = {}) {
      const res = await axios.post(localStorage.getItem('url') + 'akun/' + endpoint, data, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-API-KEY': localStorage.getItem('key') },
      })
      return res.data
    },
    async muat() {
      if (!localStorage.getItem('url')) return
      try {
        const res = await this.post('notifikasi')
        if (res.status === 'success') {
          this.daftar = res.data
          this.belum = Number(res.belum_dibaca || 0)
        }
      } catch {
        // diam: lonceng tidak boleh mengganggu halaman
      }
    },
    async buka(n) {
      if (!n.dibaca_at) {
        n.dibaca_at = 'baru'
        this.belum = Math.max(0, this.belum - 1)
        this.post('baca_notifikasi', { id: n.id }).catch(() => {})
      }
      if (n.tautan) this.$router.push(n.tautan)
    },
    async bacaSemua() {
      await this.post('baca_notifikasi').catch(() => {})
      this.muat()
    },
  },
}
</script>

<style scoped>
.lonceng-menu {
  width: 340px;
  max-height: 70vh;
  overflow-y: auto;
}
.lonceng-badge {
  font-size: 10px;
}
</style>
